import React, { useRef } from 'react';

import TopUpModal, {
  TopUpModalRef,
} from '@/components/Modals/TopUpModal/TopUpModal';
import { useCurrentUser } from '@/Utils/stripeHooks/useCurrentUser';

const TopUpBanner = () => {
  const topUpModalRef = useRef<TopUpModalRef>(null);
  const { data: user } = useCurrentUser();

  const showTopUpBanner = !!user?.balance_banner;

  if (!showTopUpBanner) return null;

  return (
    <>
      <div
        className='flex md:flex-row flex-col md:items-center flex-start text-white py-6 px-8 justify-between gap-7'
        style={{ backgroundColor: '#41A6E2' }}
      >
        <div className='flex items-center gap-7'>
          <img src='/icons/info-white.svg' alt=' ' width={20} height={20} />

          <div>
            <strong className='inline-block mb-2 font-bold text-14px leading-8'>
              Friendly Reminder: Time To Top Up!
            </strong>

            <div
              style={{
                lineHeight: '1.9rem',
                fontSize: '1.2rem',
              }}
            >
              <p>
                To keep enjoying all your benefits, please top up your balance{' '}
                <strong>(minimum {user?.balance_banner?.amount})</strong>.
              </p>

              <p>
                If you don’t top up by{' '}
                <strong>{user?.balance_banner?.deadline} </strong>you’ll be
                automatically downgraded to Proficient Pioneer plan.
              </p>
            </div>
          </div>
        </div>

        <button
          onClick={() => topUpModalRef.current?.openModal()}
          className='bg-white w-full md:w-auto text-customBlack py-4 px-6 rounded-lg transition ml-auto border-none text-16px leading-8 font-bold whitespace-nowrap'
        >
          Top Up
        </button>
      </div>

      <TopUpModal ref={topUpModalRef} />
    </>
  );
};

export default TopUpBanner;
